import z from 'zod'

import { publicEnvSchema } from './env-schema'

//
// NOTE: 本番での環境変数は、.env.productionで定義している
// （秘匿性の高い値を含むバックエンドの環境変数はterraform/KMSで定義しているが、SPAアプリにおける環境変数はどうせユーザーに露出するので、秘匿性が低く、リポジトリ内部で管理する利便性をとる判断）
//
const parsed = publicEnvSchema.parse(import.meta.env)

export const envVariables = {
  // Vite に NODE_ENV は無いので MODE（dev: development / build: production / vitest: test）を対応させる
  NODE_ENV: z
    .enum(['development', 'production', 'test'])
    .catch('development')
    .parse(import.meta.env.MODE),
  API_HOST: parsed.NEXT_PUBLIC_API_HOST,
  AUTH0_DOMAIN: parsed.NEXT_PUBLIC_AUTH0_DOMAIN,
  AUTH0_SPA_APP_CLIENT_ID: parsed.NEXT_PUBLIC_AUTH0_SPA_APP_CLIENT_ID,
  BUGSNAG_API_KEY: parsed.NEXT_PUBLIC_BUGSNAG_API_KEY,
  POSTHOG_API_KEY: parsed.NEXT_PUBLIC_POSTHOG_API_KEY,
  POSTHOG_API_URL: parsed.NEXT_PUBLIC_POSTHOG_API_URL,
}
